export default __webpack_public_path__ + "web/react/components/app-download-teaser-image/app-download-teaser-image.d6b925f665edf3f2ce04099874baa2fc.jpg";